var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionproLogoNw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.365 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1b3380;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #1b87e6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_QuestionPro",
    "data-name": "Logo QuestionPro",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QuestionPro_Cube",
    "data-name": "QuestionPro Cube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M99.654,42H74.766a3.566,3.566,0,0,1-3.556-3.556V13.556A3.566,3.566,0,0,1,74.766,10H99.654a3.566,3.566,0,0,1,3.556,3.556V38.444A3.566,3.566,0,0,1,99.654,42Z",
    transform: "translate(-71.21 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-2",
    d: "M80.693,25.117a1.867,1.867,0,1,1-1.867-1.867A1.866,1.866,0,0,1,80.693,25.117Z",
    transform: "translate(-66.738 0.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    d: "M85.9,13.1H77.01v3.556H85.9a2.667,2.667,0,1,1,0,5.333H77.01v3.556h0V29.1h3.556V25.544H85.9a6.222,6.222,0,0,0,0-12.444Z",
    transform: "translate(-66.699 -7.589)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "QuestionPro_Name",
    "data-name": "QuestionPro Name"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M101.324,32.6v1.1c0,1.3.284,1.511,1.6,1.511h1.511c.3,0,.551.124.551.427v.889c0,.427-.764.622-2.1.622-2.524,0-3.876-.676-3.876-3.378V32.6C95.6,32.172,93.2,29.737,93.2,24.581V21.239c0-5.724,2.951-8.089,6.987-8.089,4.053,0,6.951,2.364,6.951,8.089v3.324c.036,5.173-2.364,7.644-5.813,8.036m3.5-11.342c0-4.338-1.76-5.991-4.587-5.991s-4.6,1.653-4.6,5.991v3.324c0,4.338,1.778,5.991,4.6,5.991s4.587-1.653,4.587-5.991Z",
    transform: "translate(-54.107 -7.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M112.734,30.219h-1.3a.5.5,0,0,1-.5-.516v-.5A7.769,7.769,0,0,1,106.85,30.4c-3.111,0-4.48-1.938-4.48-5.351v-8.48a.528.528,0,0,1,.516-.516h1.227a.528.528,0,0,1,.516.516v8.48c0,2.613.889,3.413,2.827,3.413a8.231,8.231,0,0,0,3.467-1.013V16.566a.554.554,0,0,1,.516-.516H112.7a.538.538,0,0,1,.5.516V29.721a.448.448,0,0,1-.462.5",
    transform: "translate(-46.974 -5.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M120.55,23.924h-8.64V24.3c0,3.076,1.191,4.213,3.591,4.213a38.9,38.9,0,0,0,4.587-.284h.124a.388.388,0,0,1,.427.373v.889c0,.338-.124.516-.516.587a22.154,22.154,0,0,1-4.6.427c-2.951,0-5.849-1.387-5.849-6.187V21.987c0-3.68,2.027-6.027,5.724-6.027,3.787,0,5.689,2.364,5.689,6.027v1.387a.539.539,0,0,1-.533.551m-1.813-1.956c0-2.916-1.1-4.053-3.378-4.053-2.222,0-3.467,1.262-3.467,4.053v.249h6.862v-.249Z",
    transform: "translate(-41.297 -5.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M121.57,30.484a17.384,17.384,0,0,1-4.089-.409c-.338-.053-.551-.249-.551-.516v-.853a.414.414,0,0,1,.462-.391h.124a39.7,39.7,0,0,0,4.053.3c1.689,0,2.56-.427,2.56-1.849,0-.764-.462-1.262-1.938-2.151l-2.613-1.564c-1.564-.96-2.649-2.062-2.649-3.68,0-2.7,1.991-3.413,4.676-3.413a23.583,23.583,0,0,1,4.036.338.509.509,0,0,1,.5.516v.836a.384.384,0,0,1-.427.427h-.053c-.889-.053-2.56-.213-4-.213s-2.4.178-2.4,1.511c0,.764.587,1.262,1.778,1.973l2.56,1.511c2.151,1.262,2.827,2.364,2.827,3.911-.018,2.6-1.956,3.716-4.853,3.716",
    transform: "translate(-35.65 -5.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M131.1,31.737c-.516.053-1.191.124-1.689.124-2.364,0-3.5-.622-3.5-3.467V19.381l-2.524-.3c-.3-.036-.5-.178-.5-.462v-.711a.458.458,0,0,1,.5-.462h2.524V14.919a.53.53,0,0,1,.462-.516l1.316-.213h.053a.4.4,0,0,1,.391.427v2.827h2.773a.516.516,0,0,1,.516.516v.889a.528.528,0,0,1-.516.516h-2.773v9.013c0,1.422.373,1.636,1.387,1.636h1.44c.373,0,.551.124.551.373v.889c.053.249-.071.391-.409.462",
    transform: "translate(-31.014 -6.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M130.531,16.123h-1.316a.516.516,0,0,1-.516-.516V13.546a.516.516,0,0,1,.516-.516h1.316a.516.516,0,0,1,.516.516v2.062a.516.516,0,0,1-.516.516m-.071,16.444h-1.227a.516.516,0,0,1-.516-.516V18.9a.528.528,0,0,1,.516-.516h1.227a.516.516,0,0,1,.516.516V32.052a.485.485,0,0,1-.516.516",
    transform: "translate(-26.496 -7.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-1",
    d: "M136.934,30.484c-3.787,0-5.724-2.524-5.724-6.293V22.253c0-3.787,1.938-6.293,5.724-6.293s5.742,2.524,5.742,6.293v1.973c0,3.769-1.956,6.258-5.742,6.258m3.467-8.249c0-2.649-1.084-4.3-3.467-4.3-2.4,0-3.467,1.653-3.467,4.3v1.973c0,2.649,1.013,4.3,3.467,4.3,2.4,0,3.467-1.653,3.467-4.3Z",
    transform: "translate(-24.543 -5.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-1",
    d: "M149.161,30.3h-1.227a.516.516,0,0,1-.516-.516v-8.48c0-2.613-.889-3.413-2.827-3.413a8.231,8.231,0,0,0-3.467,1.013v10.88a.554.554,0,0,1-.516.516h-1.262a.538.538,0,0,1-.5-.516V16.633a.5.5,0,0,1,.5-.516h1.3a.5.5,0,0,1,.5.516v.5a7.723,7.723,0,0,1,4.089-1.191c3.111,0,4.48,1.938,4.48,5.351v8.48a.6.6,0,0,1-.551.533",
    transform: "translate(-18.601 -5.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-3",
    d: "M151.339,24.848c-.836,0-1.9-.053-2.578-.124v7.253a.494.494,0,0,1-.462.516h-1.387a.508.508,0,0,1-.462-.516V14a.633.633,0,0,1,.622-.64,42.132,42.132,0,0,1,4.267-.213c4.178,0,7.218,1.44,7.218,5.6v.338c0,4.284-3.04,5.76-7.218,5.76m4.871-6.116c0-2.613-1.564-3.591-4.853-3.591-.8,0-1.973.053-2.578.124v7.556c.587.036,1.9.124,2.578.124,3.538,0,4.853-1.138,4.853-3.8Z",
    transform: "translate(-12.69 -7.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-3",
    d: "M160.163,17.906a6.392,6.392,0,0,0-3.538,1.084V29.781a.554.554,0,0,1-.516.516h-1.262a.538.538,0,0,1-.5-.516V16.626a.5.5,0,0,1,.5-.516h1.191a.512.512,0,0,1,.5.516v.551a6.205,6.205,0,0,1,3.627-1.227c.373,0,.551.16.551.462V17.5c-.035.267-.213.409-.551.409",
    transform: "translate(-6.546 -5.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-3",
    d: "M164.064,30.484c-3.787,0-5.724-2.524-5.724-6.293V22.253c0-3.787,1.938-6.293,5.724-6.293s5.742,2.524,5.742,6.293v1.973c0,3.769-1.956,6.258-5.742,6.258m3.467-8.249c0-2.649-1.084-4.3-3.467-4.3-2.4,0-3.467,1.653-3.467,4.3v1.973c0,2.649,1.013,4.3,3.467,4.3,2.4,0,3.467-1.653,3.467-4.3Z",
    transform: "translate(-3.442 -5.364)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionproLogoNw);
export default __webpack_public_path__ + "static/media/questionpro-logo-nw.ad0390d28a9a56875d201f41c855c0dd.svg";
export { ForwardRef as ReactComponent };